import { useAdministrationContext } from '@openx/components-administration/lib/utils/context/AdministrationContext.tsx';
import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage.tsx';
import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { PageNotFound } from '@openx/components-core/lib/PageNotFound/PageNotFound.tsx';
import type { UsersRouteParams } from '@openx/types/user.ts';
import { useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context.ts';
import { isAdmin } from '../../permissions/validators.ts';
import { UserCreateForm } from './components/UserForm/UserCreateForm.tsx';
import { UserEditForm } from './components/UserForm/UserEditForm.tsx';

export const UserFormPage = () => {
  const { session } = useAuth();
  const { userId = '' } = useParams<UsersRouteParams>();
  const isAllowed = isAdmin(session);
  const { useUserFetch } = useAdministrationContext();
  const { user, loading } = useUserFetch(userId);

  if (!isAllowed) return <AccessForbiddenPage />;
  if (loading) return <Loader />;
  if (!userId) return <UserCreateForm />;
  if (!user) return <PageNotFound appName={'OpenXSelect'} />;

  return <UserEditForm currentUser={user} userId={userId} />;
};
